import { forwardRef } from 'react';
import PropTypes from 'prop-types';

// // Utils
import { cn } from 'utils';

import styles from './Checkbox.module.css';

const Checkbox = forwardRef(({
  className,
  label,
  onChange,
  error,
  disabled,
  theme,
  ...props
}, ref) => (
  <label htmlFor={props.id} className={cn([styles.wrapper, 'd-flex', styles[theme], className || ''])}>
    <span className={cn([styles.checkbox, disabled ? styles.disabled : ''])}>
      <input
        ref={ref}
        type="checkbox"
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      <svg viewBox="0 0 21 21">
        <polyline points="5 10.75 8.5 14.25 16 6" />
      </svg>
      {label ? (
        <span className={cn([styles.label, 'p2-desktop-default margin-left-16 p1-mobile-default'])}>
          {label}
        </span>
      ) : null}
    </span>
    {error ? (
      <span className={styles.error}>
        {error}
      </span>
    ) : null}
  </label>
));

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark', 'neutral', '']),
};

Checkbox.defaultProps = {
  className: '',
  label: null,
  error: null,
  disabled: false,
  theme: 'light',
};

export default Checkbox;
